// 判断是否为YouTube视频链接
export const isYouTubeVideo = (url: string): boolean => {
  if (!url) return false
  
  const youtubePatterns = [
    /^https?:\/\/(www\.)?youtube\.com\/watch\?v=/,
    /^https?:\/\/(www\.)?youtu\.be\//,
    /^https?:\/\/(www\.)?youtube\.com\/embed\//,
    /^https?:\/\/(www\.)?youtube\.com\/v\//
  ]
  
  return youtubePatterns.some(pattern => pattern.test(url))
}

